import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Block = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [reviewsData, setReviewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get("https://lawacademyadmin.icicle.dev/api/eventData");
        setNewsEvents(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get("https://lawacademyadmin.icicle.dev/api/courseAll");
        setCourseData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get("https://lawacademyadmin.icicle.dev/api/reviewGet");
        setReviewsData(response.data);
        console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const formatWeekday = (date) => {
    const options = { weekday: "short" };
    return new Date(date).toLocaleDateString("en-US", options);
  };

  return (
    <div className="block-links">
      <div className="container">
        <div className="row">
          <div data-aos="fade-right" className="block-news col-md-4 col-sm-12 col-xs-12">
            <div className="column-news">
              <div className="title-links">
                <h3 className="heading-regular">News & Events</h3>
              </div>
              <div className="members-directory post-wrapper">
                {newsEvents?.map((event, index) => (
                  <div key={index} className="post-item clearfix ">
                    <div className="image-frame post-photo-wrapper">
                      <img
                        src={`https://lawacademyadmin.icicle.dev/${event?.image}`}
                        alt=""
                        style={{ height: "100px" }}
                      />
                    </div>
                    <div className="post-desc-wrapper">
                      <div className="post-desc">
                        <div className="post-title">
                          <h6 className="heading-regular">
                            <a href="#.">{event?.title}</a>
                          </h6>
                        </div>

                        <div className="post-excerpt">
                          <p>{event?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="view-all">
                <a href="#">View All News</a>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" className="block-career col-md-4 col-sm-12 col-xs-12">
            <div className="column-career ">
              <div className="title-links">
                <h3 className="heading-regular">Students Reviews</h3>
              </div>
              <div className="career-content members-directory" style={{ padding: "0px 5px" }}>
                {reviewsData.map((reviews, idx) => (
                  <div
                    key={idx}
                    style={{
                      padding: "5px 0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      borderBottom: "1px solid #e2eafc",
                    }}
                  >
                    <p style={{ textAlign: "justify", fontSize: "12px", paddingBottom: "10px" }}>
                      {reviews?.review}
                    </p>
                    <div>
                      {Array.from({ length: reviews?.star }, (_, staridx) => (
                        <img
                          style={{ marginRight: "2px" }}
                          width={10}
                          key={staridx + 1}
                          src="/assets/images/star.png"
                          alt="Star"
                        />
                      ))}
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        fontFamily: "Arvo",
                        fontWeight: "bold",
                      }}
                    >
                      {reviews?.student_name}
                    </p>
                  </div>
                ))}
              </div>
              <div className="view-all">
                <Link to="/association">View All Advocate Directory</Link>
              </div>
            </div>
          </div>
          <div data-aos="fade-left" className="block-event-calendar col-md-4 col-sm-12 col-xs-12">
            <div className="column-calendar">
              <div className="title-links">
                <h3 className="heading-regular">Course Calendar</h3>
              </div>
              <div className="content-calendar bg-calendar no-padding">
                <div className="members-directory list-view">
                  {courseData?.map((event, index) => (
                    <div key={index} className="view-item">
                      <div className="date-item">
                        <span className="date-time dates text-light">
                          {formatWeekday(event?.start_date)}
                        </span>
                        <span className="date-time day text-bold color-theme">
                          {new Date(event?.start_date).getDate()}
                        </span>
                        <span className="date-time month text-light">
                          {new Date(event?.start_date).toLocaleString("en-US", {
                            month: "short",
                          })}
                        </span>
                      </div>
                      <div className="date-desc-wrapper">
                        <div className="date-desc">
                          <div className="date-title">
                            <h6 className="heading-regular">{event?.title}</h6>
                          </div>
                          <div className="date-excerpt">
                            <p>Organizer: {event?.description}</p>
                          </div>
                          <div className="place">
                            <span className="text-place">{event?.days}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="view-all">
                <a href="#.">View All Courses</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Block;
